import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { InterviewSidebarComponent } from '../home/interview-sidebar/interview-sidebar.component';

@Component({
  selector: 'app-mock-interview',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzStatisticModule,
    NzButtonModule,
    InterviewSidebarComponent,
    YouTubePlayerModule,
  ],
  templateUrl: './mock-interview.component.html',
  styleUrl: './mock-interview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MockInterviewComponent {}
